export const validateEmail = (email: string): boolean => {
  const emailMatch = (email || "")
    .trim().match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i);
  return !!emailMatch && !!emailMatch.length;
};
